import {Vue} from "ui.vue";

import Multiselect from './Multiselect.vue';
import multiselectMixin from './multiselectMixin.js';
import pointerMixin from './pointerMixin.js';

export { Multiselect, multiselectMixin, pointerMixin };

Vue.component("CitrusVueMultiselect", Multiselect);

export default {
	install(Vue, options = {}) {
		Vue.component("CitrusVueMultiselect", Multiselect);
	}
}